document.addEventListener('DOMContentLoaded', () => {
  const lockBodyScrollClass = 'lock-body-scroll'
  let scrollY = 0
  let hadLockedBodyClass = false
  const mutationObserver = new MutationObserver(() => {
    // only process real class changes
    const hasLockedBodyClass = document.body.classList.contains(lockBodyScrollClass)
    if (hasLockedBodyClass !== hadLockedBodyClass) {
      if (hasLockedBodyClass) {
        // apply scroll lock
        scrollY = window.scrollY
        document.body.style.position = 'fixed'
        document.body.style.top = `calc(var(--adminbar-height) + -${scrollY}px)`
        document.documentElement.style.overflowY = 'scroll'
      } else {
        // remove scroll lock
        document.body.style.position = ''
        document.body.style.top = ''

        // scroll back to previous Y position
        // disable smooth scroll, otherwise we might have some visual glitches
        document.documentElement.style.scrollBehavior = 'auto'
        document.documentElement.style.overflowY = ''
        window.scrollTo(0, parseInt(scrollY * -1 || '0', 10) * -1)

        // restore previous scroll behavior
        const resetScrollBehaviorTimeout = 50
        setTimeout(() => {
          document.documentElement.style.scrollBehavior = ''
        }, resetScrollBehaviorTimeout)
      }
    }

    hadLockedBodyClass = hasLockedBodyClass
  })

  mutationObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  })
})
